import {
  FullScreenIcon,
  MinimizeIcon,
} from "@/pages/charts/highcharts/charts_custom_svgs"
import * as ChartCommons from "@/pages/charts/highcharts/common"
import { theme } from "@/tailwind.config"
import { Dispatch, SetStateAction } from "react"

interface RenderFullScreenButtonParams {
  chart: any
  isOpen: boolean
  setIsOpen: Dispatch<SetStateAction<boolean>>
}

export function renderFullScreenButton({
  chart,
  isOpen,
  setIsOpen,
}: RenderFullScreenButtonParams) {
  if (!chart.fsBtn && !isOpen) {
    chart.fsBtn = chart.renderer
      .button(
        FullScreenIcon,
        5,
        5,
        function () {
          setIsOpen(true)
        },
        {
          fill: ChartCommons.hexToRGBA(theme.colors.main[200], 0.6),
          stroke: "transparent",
          padding: 2,
        }, // Theme for regular state,
        {
          fill: ChartCommons.hexToRGBA(theme.colors.main[200], 0.6),
          padding: 2,
        }, // Theme for hover state,
        undefined,
        undefined,
        "rect",
        true
      )
      .attr({
        zIndex: 3,
        fill: ChartCommons.hexToRGBA(theme.colors.main[200], 0.6),
        strokeWidth: 0,
        padding: 2,
      })
      .add()

    chart.fsBtn.addClass("print:hidden")
  } else if (!chart.fsOutBtn && isOpen) {
    chart.fsOutBtn = chart.renderer
      .button(
        MinimizeIcon,
        5,
        5,
        function () {
          setIsOpen(false)
        },
        {
          fill: ChartCommons.hexToRGBA(theme.colors.main[200], 0.6),
          stroke: "transparent",
          padding: 2,
        }, // Theme for regular state,
        {
          fill: ChartCommons.hexToRGBA(theme.colors.main[200], 0.6),
          padding: 2,
        }, // Theme for hover state,
        undefined,
        undefined,
        "rect",
        true
      )
      .attr({
        zIndex: 3,
        fill: ChartCommons.hexToRGBA(theme.colors.main[200], 0.6),
        strokeWidth: 0,
        padding: 2,
      })
      .add()
    chart.fsOutBtn.addClass("print:hidden")
  }
}
